import { Avatar, Button, ButtonGroup, Grid, Paper } from "@material-ui/core";
import React, { useCallback, useEffect, useRef, useState } from "react";
import InputDatePicker from "../../../components/InputDatePicker";
import { AccessAlarm, CheckCircleOutline, FiberNew, Close } from "@material-ui/icons";
import { getColumnsTable, initialTableOptions, useStylesEmergency } from "../helpers/emerManageEvtOp";
import MaterialTable from "material-table";
import { countEmergency, getEmergency, updateEmergency } from "../../../../api/emergencyApi";
import moment from "moment";
import { io } from "socket.io-client";
import sound from "../../../../sound/emergencySound2.mp3";
import { useSelector } from "react-redux";
import { swalCondition } from "../../../../utils/swalHelper";

export default function ContentL({ handleViewMap }) {
    const classes = useStylesEmergency();

    // ref
    const tableRef = useRef(null);

    // global redux state
    const { thisMenuPermission } = useSelector(state => {
        const { menuPermission } = state?.menu;
        return {
            thisMenuPermission: menuPermission?.find(menu => menu?.path === window.location.pathname)?.permission,
        };
    });

    // component state
    // const [isLoading, setIsLoading] = useState(false);
    const [datePick, setDatePick] = useState(new Date());
    const [valueFillter, setValueFillter] = useState("");
    const controllerRef = useRef(null);
    const [tableOptions, setTableOptions] = useState(initialTableOptions);
    const [isLoading, setIsLoading] = useState(false);
    const [countEmergencyData, setCountEmergencyData] = useState({});
    const [audio, setAudio] = useState(new Audio(sound));

    // change emergency
    const handleDate = useCallback(date => {
        setDatePick(date);
        tableRef.current.onQueryChange();
    }, []);

    const handleOnChangeStatus = useCallback(async data => {
        try {
            //update user
            const isUpdateEmergency = await updateEmergency(
                data?.obj?.emergencyId,
                { status: data?.val },
                controllerRef.current?.signal,
            );
            if (isUpdateEmergency) {
                tableRef.current.onQueryChange();
            }
        } catch (error) {
            console.log(error);
        }
    }, []);

    const getFilterTable = useCallback(
        async value => {
            setValueFillter(value);
            tableRef.current.dataManager.changeSearchText(value);
            tableRef.current.setState({ searchText: value });
            tableRef.current.setState(tableRef.current.dataManager.getRenderState());
        },
        [setValueFillter],
    );

    const fetchData = useCallback(
        async query => {
            try {
                const queryParams = {
                    page: query?.page + 1 || 1,
                    limit: query?.pageSize || 10,
                    order: query?.orderBy?.field || "emergencyId",
                    direction: query?.orderBy?.field ? query?.orderDirection : "desc",
                    status: tableRef.current.state.searchText,
                    date: moment(datePick).format("YYYY-MM-DD"),
                };
                const res = await getEmergency(queryParams, controllerRef.current?.signal);
                const countData = await countEmergency(
                    { date: moment(datePick).format("YYYY-MM-DD") },
                    controllerRef.current?.signal,
                );
                if (res) {
                    setCountEmergencyData(countData);
                    setTableOptions(currentState => ({
                        ...currentState,
                        currentPage: query?.page,
                        pageSize: query?.pageSize || 10,
                        totalData: res?.pagination?.totalData || 0,
                        order: query?.orderBy?.field || "timestamp",
                        direction: query?.orderBy?.field ? query?.orderDirection : "desc",
                    }));
                    setIsLoading(false);
                    return {
                        data: res?.data || [],
                        page: query?.page || 0,
                        totalCount: res?.pagination?.totalData || 0,
                    };
                }
                setIsLoading(false);
            } catch (error) {}
        },
        [datePick],
    );

    const playSound = useCallback(() => {
        setAudio(currentState => {
            currentState.loop = true;
            return currentState;
        });
        audio.play();
    }, [audio]);

    const stopSound = useCallback(() => {
        setAudio(currentState => {
            currentState.loop = false;
            return currentState;
        });
        audio.pause();
    }, [audio]);

    useEffect(() => {
        async function filterTable() {
            const fn = await tableRef?.current?.onFilterChange;
            const columnId = await tableRef?.current?.state.columns.filter(column => column.field === "status");
            await fn(columnId[0]?.tableData?.id, valueFillter);
        }
        if (tableRef !== null) {
            filterTable();
        }
    }, [valueFillter]);

    // connect socket.io
    useEffect(() => {
        const socket = io(`${process.env?.REACT_APP_HOST_SOCKET_MOBILE}/emergency`, {
            transports: ["websocket"],
        });

        socket.on("display-emergency", () => {
            swalCondition('<div className="h3 t-text-primary">Emergency !!!</div>', "", {
                icon: "warning",
                showCancelButton: false,
                confirmButtonText: "OK",
                confirmCallback: () => stopSound(),
            });
            playSound();
            tableRef.current.onQueryChange();
        });

        return () => {
            socket.off("connect");
            socket.off("display-emergency");
            socket.emit("leave-emergency-namespace");
        };
    }, [playSound, stopSound]);

    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <Grid container spacing={0}>
                    <Grid item xs={12} md={10} lg={8}>
                        <InputDatePicker value={datePick} onChange={handleDate} />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={10} lg={8}>
                <div className="d-flex justify-content-between mt-5">
                    <div>
                        <div className="d-flex align-items-center">
                            <Avatar variant="rounded" style={{ background: "#46BBE7" }}>
                                <FiberNew style={{ width: 35, height: 35 }} />
                            </Avatar>
                            <div style={{ paddingLeft: 5 }}>
                                <p className="mb-0 text-dark-50">New</p>
                                <p className="mb-0 h4 t-text-blue-dark">{countEmergencyData?.countDataNew}</p>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="d-flex align-items-center">
                            <Avatar variant="rounded" style={{ background: "#e5172d" }}>
                                <AccessAlarm style={{ width: 35, height: 35 }} />
                            </Avatar>
                            <div style={{ paddingLeft: 5 }}>
                                <p className="mb-0 text-dark-50">Processing</p>
                                <p className="mb-0 h4 t-text-blue-dark">{countEmergencyData?.countDataProcessing}</p>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="d-flex align-items-center">
                            <Avatar variant="rounded" style={{ background: "#17a56b" }}>
                                <CheckCircleOutline style={{ width: 35, height: 35 }} />
                            </Avatar>
                            <div style={{ paddingLeft: 5 }}>
                                <p className="mb-0 text-dark-50">Completed</p>
                                <p className="mb-0 h4 t-text-blue-dark">{countEmergencyData?.countDataCompleted}</p>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="d-flex align-items-center">
                            <Avatar variant="rounded" style={{ background: "#7A7776" }}>
                                <Close style={{ width: 35, height: 35 }} />
                            </Avatar>
                            <div style={{ paddingLeft: 5 }}>
                                <p className="mb-0 text-dark-50">Cancel</p>
                                <p className="mb-0 h4 t-text-blue-dark">{countEmergencyData?.countDataCancel}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Grid>

            {/* table */}
            <Grid item xs={12} className="mt-5 mt-md-10">
                <ButtonGroup
                    disableElevation
                    variant="contained"
                    className={`mb-5 ${classes.ButtonGroupStyle}`}
                    fullWidth>
                    <Button onClick={() => getFilterTable("")} className={valueFillter === "" && "active"}>
                        All
                    </Button>
                    <Button onClick={() => getFilterTable("0")} className={valueFillter === "0" && "active"}>
                        New
                    </Button>
                    <Button onClick={() => getFilterTable("1")} className={valueFillter === "1" && "active"}>
                        Processing
                    </Button>
                    <Button onClick={() => getFilterTable("2")} className={valueFillter === "2" && "active"}>
                        Complete
                    </Button>
                    <Button onClick={() => getFilterTable("3")} className={valueFillter === "3" && "active"}>
                        Cancel
                    </Button>
                </ButtonGroup>

                <div className={`t-table-custom ${classes.tableStyle}`}>
                    <MaterialTable
                        tableRef={tableRef}
                        title={""}
                        options={tableOptions}
                        isLoading={isLoading}
                        components={{
                            Container: props => <Paper elevation={0} className="p-5" {...props} />,
                            Toolbar: props => null,
                        }}
                        data={fetchData}
                        columns={getColumnsTable({ handleViewMap, handleOnChangeStatus, thisMenuPermission })}
                    />
                </div>
            </Grid>
        </Grid>
    );
}
